module.exports = __webpack_public_path__ + "img/main-summer_m.4f74344e.jpg";